import React, { useState } from 'react';

import { 
  ModelBase,
} from "@models";
import { 
  Environment, 
} from "@dndModels";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function EnvironmentEdit({ obj: param_obj }: Props) {
  const [obj, setObj] = useState<Environment>(param_obj instanceof Environment ? param_obj : api.applyWorkingOn(new Environment()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);

  return (
    <ModelBaseInput
      obj={obj}
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: ModelBase) => {
        if (changed instanceof Environment) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}
    />
  );
}
